import { Backdrop, CircularProgress, Typography } from "@mui/material";
import React from "react";

const Loader = ({text}) => {
  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "#3b3b3b00",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
      }}
      open={true}

    >
      <CircularProgress color="inherit" />{" "}
      <Typography sx={{fontWeight:600}}>Loading {text} ...</Typography>
    </Backdrop>
  );
};

export default Loader;
